const basePattern = "^[a-zA-Z0-9\\s'’&_"

const accents = {
  acute: 'áéíóúýÁÉÍÓÚÝ',
  grave: 'àèìòùÀÈÌÒÙ',
  circumflex: 'âêîôûŵŷÂÊÎÔÛŴŶ',
  tilde: 'ãñõÃÑÕ',
  umlaut: 'äëïöüÿÄËÏÖÜŸ',
  cedilla: 'çÇ',
  caron: 'čšžČŠŽ',
  macron: 'āĒīŌūĀĒĪŌŪ',
  ogonek: 'ąęĄĘ',
  doubleAcute: 'őűŐŰ',
  ringAbove: 'åÅ',
  dotAbove: 'żŻ',
  breve: 'ğĞ',
  additional: 'łøæœÅåØÆŒ',
}

const allDiacriticals = Object.values(accents).join('')

const diacriticalRegex = new RegExp(`${basePattern}${allDiacriticals}-]*$`)

export const validateInput = (input: string) => {
  return input === '' ? false : diacriticalRegex.test(input)
}
